import { render, staticRenderFns } from "./ImageWithModal.vue?vue&type=template&id=5efe14d4&"
import script from "./ImageWithModal.vue?vue&type=script&lang=ts&"
export * from "./ImageWithModal.vue?vue&type=script&lang=ts&"
import style0 from "./ImageWithModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports